import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

export const ProductDetailLeft = () => {
	const responsive = {
		superLargeDesktop: {
			// the naming can be any, depends on you.
			breakpoint: { max: 4000, min: 3000 },
			items: 5
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: 4
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1
		}
	};

	return (
		<>
			<div className="product_slider w-full md:w-2/4 lg:w-2/3 pt-8 lg:py-8 lg:hidden">
				<Carousel emulateTouch={true} infiniteLoop={true} interval={8000} stopOnHover={true} autoPlay={true}>
					<img src="images/product-01.jpg" alt="Product" />
					<img src="images/product-02.jpg" alt="Product" />
					<img src="images/product-03.jpg" alt="Product" />
					<img src="images/product-04.jpg" alt="Product" />
					<img src="images/product-05.jpg" alt="Product" />
					<img src="images/product-06.jpg" alt="Product" />
					<img src="images/product-07.jpg" alt="Product" />
					<img src="images/product-08.jpg" alt="Product" />
				</Carousel>
			</div>
			<div className="w-full lg:w-2/3 pt-8 lg:py-8 hidden lg:block">
				<ul className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 gap-6">
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-1.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-2.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-3.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-4.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-5.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-6.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-7.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-8.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-9.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
					<li className="border border-gray-200 rounded-md overflow-hidden"><Link to="#"><img src="images/product-10.jpeg" alt="Product" className="hover:scale-110 transition duration-500" /></Link></li>
				</ul>
			</div>
		</>
	)
}